export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10834.6f1bb787.jpg";